import React, { useEffect, useState } from "react";
import DashPlayer from "../tools/DashVideoPlayer";
import { useSelector } from "react-redux";
import { Box, Typography, CircularProgress } from "@mui/material";

const VideoPlayer = ({ videoId, language = "fr" }) => {
  const userState = useSelector((state) => state.user);

  // Create the base path without the .mpd extension
  const basePath = encodeURIComponent(`${language}/${videoId}/${videoId}`);

  return (
    <Box sx={{ width: "100%" }}>
      {userState?.token ? (
        <DashPlayer
          url={`${process.env.REACT_APP_API_URL}/Recipe/GetVideoPart/${basePath}.mpd`}
          token={userState.token}
          language={language}
          videoId={videoId}
        />
      ) : (
        <Box sx={{ p: 2, textAlign: "center" }}>
          <Typography>Waiting for authentication...</Typography>
        </Box>
      )}
    </Box>
  );
};

export default VideoPlayer;
